<zah-clienten-filter
  [enableZonesAndDienstenFilter]="false"
  (newSearch)="onSearch($event)">
</zah-clienten-filter>

@if (clientenPage) {
  <mat-nav-list>
    <h3 class="subheader">
      Cliënten
      @if (!clientenPage.isEmpty()) {
        <zah-sort-button
          [sortOrder]="initialPageRequest.getSortOrder()"
          (sortOrderChange)="onSortOrderChange($event)">
        </zah-sort-button>
      }
    </h3>
    @for (client of clientenPage.getItems(); track client) {
      <mat-list-item (click)="onClientClick(client)"
        [class.archived]="client.isGearchiveerd()">
        <zah-avatar matListItemAvatar
          [color]="client.isGearchiveerd() ? 'disabled': 'primary'"
          [name]="client.getNaam()">
        </zah-avatar>
        <div matListItemTitle>{{client.getNaam()}}</div>
        <div matListItemLine class="mat-small">{{client.getAdres() | zahStraat}}
        - {{client.getAdres() | zahGemeente}}</div>
      </mat-list-item>
      <mat-divider></mat-divider>
    }
    @if (clientenPage.isEmpty()) {
      <mat-list-item
        class="no-list-item-highlight"
        disableRipple>
        <div matListItemTitle>Geen cliënten gevonden</div>
      </mat-list-item>
    }
  </mat-nav-list>
  <zah-paginator [currentPage]="clientenPage"
    [pageSize]="initialPageRequest.getPageSize()"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)">
  </zah-paginator>
}
